import config from '../config';

class Api {
  async request(url, options = {}) {
    const { method = 'GET', headers = {}, body, timeout = 30000 } = options;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: controller.signal,
      });

      if (!response.ok) {
        if (response.status === 429) {
          throw new Error('You have reached the generation limit (30 per 30 minutes). Please wait a moment and try again.');
        }
        const errorText = await response.text();
        throw new Error(`API error ${response.status}: ${errorText}`);
      }

      return await response.json();
    } catch (err) {
      if (err.name === 'AbortError') {
        throw new Error('Request timed out');
      }
      throw err;
    } finally {
      clearTimeout(timeoutId);
    }
  }

  // Server-side proxy call (API key stays on server)
  async proxyCall(action, params = {}) {
    const data = await this.request(config.apiUrl, {
      method: 'POST',
      timeout: 60000,
      body: {
        action,
        ...params,
      },
    });
    return data;
  }

  // Generate text via server proxy → OpenAI
  async generateText(prompt) {
    const data = await this.proxyCall('generate', { prompt });
    if (!data.text) {
      throw new Error('No response from AI');
    }
    return data.text;
  }
}

const api = new Api();
export default api;
